import {action} from 'mobx';

import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';
import ApiPaginationStore from '../common/apiPaginationStore';

/**
 * Get all sheets for a company from the Schedule database.
 */
class ApiCompanyScheduleSheetsGetMineStore extends ApiPaginationStore {
  /**
   * Get all sheets for the company using the scheduler api.
   *
   * @param {{}} data
   * @param {number?} data.page pass through which page should be used
   * @param {string?} data.search search string
   * @param {string?} data.sort sort field
   * @param {string?} data.direction sort direction
   */
  @action makeRequest({
    page = 1,
    search = '',
    sort = 'updatedAt',
    direction = 'desc',
  }) {
    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.scheduleSheetsGet({
      isGlobal: 0,
      page,
      search,
      sort,
      direction,
    }).then(
      action('scheduleSheetGetMineSuccess', (foundSheets) => {
        this.state = STATE_FULFILLED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        // if page is greater than current page, append results
        if (this.meta && this.meta.current_page && page > this.meta.current_page) {
          this.data = [...(this.data || []), ...foundSheets.data];
        } else {
          // else replace data
          this.data = [...foundSheets.data];
        }

        this.meta = foundSheets.meta;
        this.error = null;
      }),
      action('scheduleSheetSignGetMineError', (sheetsGetMineError) => {
        this.state = STATE_REJECTED;
        this[EXPIRE_TIME] = null;
        this.data = null;
        this.meta = null;
        this.error = sheetsGetMineError;
      })
    ).catch(
      action('scheduleSheetGetAllError', (sheetsGetMineError) => {
        this.state = STATE_FULFILLED;
        this.data = null;
        this.error = sheetsGetMineError;
      })
    );
  }
}

export default new ApiCompanyScheduleSheetsGetMineStore();
